/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_StartedInputs */

const en_directory_ai_tools_studio_started = /** @type {(inputs: Directory_Ai_Tools_Studio_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering started. Your video will appear below in a few minutes.`)
};

const zh_directory_ai_tools_studio_started = /** @type {(inputs: Directory_Ai_Tools_Studio_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已开始生成，几分钟后视频会出现在下方。`)
};

/**
* | output |
* | --- |
* | "Rendering started. Your video will appear below in a few minutes." |
*
* @param {Directory_Ai_Tools_Studio_StartedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_started = /** @type {((inputs?: Directory_Ai_Tools_Studio_StartedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_StartedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_started(inputs)
	return zh_directory_ai_tools_studio_started(inputs)
});
export { directory_ai_tools_studio_started as "directory.ai_tools.studio.started" }